import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // स्क्रॉल को टॉप पर ले जाएं
  }, [pathname]); // जब भी pathname (रूट) बदलता है, यह ट्रिगर होगा

  return null; // यह एक "खाली" कंपोनेंट है, कुछ भी रेंडर नहीं करता
};

export default ScrollToTop;